import React from 'react';

interface TextFieldProps extends React.InputHTMLAttributes<HTMLInputElement> {
    error?: string;
    label: string;
}

const TextField = React.forwardRef(function TextField(
    { error, label, name, type, autoFocus = false, autoComplete, ...fieldProps }: TextFieldProps,
    ref: React.RefObject<HTMLInputElement>
) {
    return (
        <div className="field field--no-margin-bottom" data-field-error={error ? true : undefined}>
            <label htmlFor={name} className="field__title">
                {label}
            </label>
            {error && (
                <div className="field__validation">
                    <p className="field__validation__message" role="alert" id={`${name}-error`}>
                        {error}
                    </p>
                </div>
            )}
            <div className="field__input">
                <input
                    className="input-text"
                    aria-invalid={!!error}
                    aria-describedby={`${name}-error`}
                    id={name}
                    name={name}
                    ref={ref}
                    type={type}
                    autoFocus={autoFocus}
                    autoComplete={autoComplete}
                    {...fieldProps}
                />
            </div>
        </div>
    );
});

export default TextField;
